import { getChainId, } from "wagmi/actions";
import { wagmiConfig as config, } from "@wagmiconfig";
import { getExplorerLink, } from "@bracket/chainography";

import type { BlockHash, } from "@bracket/types";
import type { ResolverResult, } from "@types";
import type { Notification } from "@bracket/ui";

export const dispatchClaimNotification = (result: ResolverResult): Omit<Notification, "id"> | null => {
	if(result.success) {
		return claimSuccessNotification(result.hash);
	}
	if(result.rejected) {
		return null;
	}
	return claimFailedNotification(result.error);
}


export const claimSuccessNotification = (
	hash: BlockHash,
): Omit<Notification, "id"> => {
	return {
		title: "Claim successful",
		message: "You successfully claimed for this vault",
		type: "success",
		status: "success",
		primaryAction: {
			label: "View on explorer",
			onClick: () => {
				window.open(getExplorerLink(hash, getChainId(config)), "_blank");
			},
		},
	}
}


export const claimFailedNotification = (error: Error): Omit<Notification, "id"> => {

  const msg = error.message.toLowerCase();
	const message = (
		// msg.includes("not a weistring") ? "invalid input, please check your values and try again" :
		// msg.includes("vaultnotlocked") ? "vault is not locked, please lock the vault before updating the NAV" :
		"please try again"
	);

	console.warn("claim failed", error.message);

	return {
		title: "Claim failure",
		message: `Your claim for this vault failed, ${message}`,
		type: "error",
		status: "error",
	}

}
